import { takeLatest, call, put } from 'redux-saga/effects';
import { getSearchById, selectCar, getSelectedCarById } from 'api';
import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
import * as actions from './actions';

function* getHandl(action) {
  const { payload: { id } } = action;

  try {
    const result = yield call(getSearchById, id);
    yield put(showLoadScreen());
    yield put(actions.setCar(result.data.car));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log('ERR', err);
  }
}

function* addCarHandl(action) {
  const { payload: { id, callback } } = action;

  try {
    yield call(selectCar, id);
    if (callback) callback();
  } catch (err) {
    console.log('ERR', err);
  }
}

function* getCarById(action) {
  const { payload: { id } } = action;

  try {
    yield put(showLoadScreen());
    yield call(getSelectedCarById, id);
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log('ERROR', err);
  }
}

export default function* () {
  yield takeLatest(
    actions.CAR_GET,
    getHandl
  );
  yield takeLatest(
    actions.CAR_ADD,
    addCarHandl
  );
  yield takeLatest(
    actions.CAR_GET_ID,
    getCarById
  );
}



// WEBPACK FOOTER //
// ./src/pages/CarPage/saga.js